import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { Link } from 'react-router-dom';

//IMG IMPORT
import pvcInstallation from "../images/pvc-installation.webp";

import aluwindows from "../images/alu-windows.webp";
import pvcwindow from "../images/pvc-window.webp";
import komarnici from "../images/komarnici.webp";
import roletne from "../images/roletne.webp";
import pvcvrata from "../images/pvcvrata.webp";

import nr1 from "../images/nasiradovi/nr1.webp";
import nr2 from "../images/nasiradovi/nr2.webp";
import nr3 from "../images/nasiradovi/nr3.webp";
import SEO from "../Components/SEO";

function Home() {
    return (
        <>
            <SEO
                title="Početna | ALU i PVC stolarija JODUST Lebane"
                description="JODUST - profesionalna proizvodnja i montaža ALU i PVC stolarije. Prozori, vrata, klizni sistemi po meri. Kvalitetni materijali, povoljne cene, garancija. Poslujemo u Lebanu, Leskovcu i širom Srbije."
                keywords="ALU stolarija Lebane, PVC stolarija Leskovac, prozori po meri, vrata, klizni sistemi, montaža stolarije, JODUST"
            />
            <main>

                {/* HERO */}
                <section
                    className="text-white text-center py-5"
                    style={{ backgroundColor: "#1f4068" }}
                >
                    <div className="container py-5">

                        <h1 className="display-4 fw-bold">
                            JODUST ALU i PVC Stolarija
                        </h1>

                        <p className="lead mt-3">
                            Profesionalna ugradnja PVC i aluminijumske stolarije.
                            Prozori, vrata, roletne, komarnici i ograde vrhunskog kvaliteta.
                        </p>

                        <Link to="/contact" className="btn btn-warning btn-lg mt-3">
                            Kontaktirajte nas
                        </Link>

                    </div>
                </section>

                {/* ABOUT */}
                <section className="py-5">
                    <div className="container">

                        <div className="row align-items-center">

                            <div className="col-lg-6">
                                <img
                                    src={pvcInstallation}
                                    className="img-fluid rounded shadow"
                                    alt="Ugradnja PVC prozora"
                                />
                            </div>

                            <div className="col-lg-6">

                                <h2 className="fw-bold mb-3">
                                    Kvalitetna ALU i PVC stolarija
                                </h2>

                                <p>
                                    JODUST je firma specijalizovana za izradu i ugradnju
                                    aluminijumske i PVC stolarije. Naš cilj je da obezbedimo
                                    dugotrajna, energetski efikasna i estetski moderna rešenja
                                    za vaš dom ili poslovni prostor.
                                </p>

                                <p>
                                    Koristimo kvalitetne profile i profesionalnu montažu kako
                                    bismo osigurali maksimalnu izolaciju, sigurnost i dug vek
                                    trajanja proizvoda.
                                </p>
                                <p>
                                    <Link to="/about" className="btn btn-warning btn-lg mt-3">
                                        Opširnije o nama
                                    </Link>
                                </p>

                            </div>

                        </div>

                    </div>
                </section>
                <section className="py-5 bg-light">
                    <div className="container text-center">

                        {/* Tekst iznad slike */}
                        <h2 className="fw-bold mb-3">
                            Poslujemo širom Srbije i regiona
                        </h2>
                        <p className="lead mb-4">
                            JODUST pruža vrhunske usluge u oblasti ALU i PVC stolarije, sa
                            profesionalnom ugradnjom i prodajom za privatne i poslovne klijente.
                            Naši proizvodi se koriste širom Srbije, a takođe sarađujemo i sa
                            klijentima u regionu.
                        </p>
                    </div>
                </section>
                {/* SERVICES */}
                <section className="bg-light py-5">
                    <div className="container">
                        <h2 className="text-center fw-bold mb-5">
                            Ukratko o našim uslugama
                        </h2>

                        {/* PVC prozori */}
                        <div className="row align-items-center mb-5">
                            <div className="col-md-6">
                                <img
                                    src={pvcwindow}
                                    alt="PVC prozori"
                                    className="img-fluid rounded shadow"
                                />
                            </div>
                            <div className="col-md-6">
                                <h3>PVC prozori</h3>
                                <p>
                                    Energetski efikasni PVC prozori sa odličnom toplotnom i zvučnom izolacijom.
                                </p>
                            </div>
                        </div>

                        {/* ALU stolarija */}
                        <div className="row align-items-center mb-5 flex-md-row-reverse">
                            <div className="col-md-6">
                                <img
                                    src={aluwindows}
                                    alt="ALU stolarija"
                                    className="img-fluid rounded shadow"
                                />
                            </div>
                            <div className="col-md-6">
                                <h3>ALU stolarija</h3>
                                <p>
                                    Moderni aluminijumski sistemi idealni za poslovne objekte i savremene domove.
                                </p>
                            </div>
                        </div>

                        {/* Roletne */}
                        <div className="row align-items-center mb-5">
                            <div className="col-md-6">
                                <img
                                    src={roletne}
                                    alt="Roletne i komarnici"
                                    className="img-fluid rounded shadow"
                                />
                            </div>
                            <div className="col-md-6">
                                <h3>Roletne</h3>
                                <p>
                                    Zaštita od sunca i insekata uz moderan izgled i jednostavno korišćenje.
                                </p>
                            </div>
                        </div>
                        {/* Vrata i ograde */}
                        <div className="row align-items-center mb-5 flex-md-row-reverse">
                            <div className="col-md-6">
                                <img
                                    src={pvcvrata}
                                    alt="Vrata i ograde"
                                    className="img-fluid rounded shadow"
                                />
                            </div>
                            <div className="col-md-6">
                                <h3>Vrata i ograde</h3>
                                <p>
                                    Kvalitetna ulazna vrata i aluminijumske ograde modernog dizajna.
                                </p>
                            </div>
                        </div>
                        {/* Roletne i komarnici */}
                        <div className="row align-items-center mb-5">
                            <div className="col-md-6">
                                <img
                                    src={komarnici}
                                    alt="Roletne i komarnici"
                                    className="img-fluid rounded shadow"
                                />
                            </div>
                            <div className="col-md-6">
                                <h3>Komarnici</h3>
                                <p>
                                    Mreža visokog kvaliteta pruža zaštitu od insekata i komaraca.
                                </p>
                            </div>
                        </div>



                        {/* Centrirani tekst i dugme ispod slika */}
                        <div className="text-center mt-5">
                            <h2 className="fw-bold mb-3">
                                Pogledajte naš katalog
                            </h2>
                            <Link to="/Katalog" className="btn btn-warning btn-lg">
                                Katalog
                            </Link>
                        </div>
                    </div>
                </section>

                {/* PROJECTS */}
                <section className="py-5">
                    <div className="container">

                        <h2 className="text-center fw-bold mb-5">
                            Neki od naših radova
                        </h2>

                        <div className="row g-4">

                            <div className="col-md-4">
                                <img
                                    src={nr1}
                                    className="img-fluid rounded shadow"
                                    alt="PVC prozori instalacija"
                                />
                            </div>

                            <div className="col-md-4">
                                <img
                                    src={nr2}
                                    className="img-fluid rounded shadow"
                                    alt="Aluminijumska vrata"
                                />
                            </div>

                            <div className="col-md-4">
                                <img
                                    src={nr3}
                                    className="img-fluid rounded shadow"
                                    alt="Aluminijumska ograda"
                                />
                            </div>

                        </div>

                        {/* Centrirani tekst i dugme ispod slika */}
                        <div className="text-center mt-5">
                            <h2 className="fw-bold mb-3">
                                Više o našim radovima
                            </h2>
                            <Link to="/Blog" className="btn btn-warning btn-lg">
                                Naši radovi
                            </Link>
                        </div>

                    </div>
                </section>

                {/* CTA */}
                <section
                    className="text-white text-center py-5"
                    style={{ backgroundColor: "#1f4068" }}
                >
                    <div className="container">

                        <h2 className="fw-bold">
                            Potrebna vam je nova stolarija?
                        </h2>

                        <p className="lead mt-3">
                            Kontaktirajte nas za procenu i ponudu.
                        </p>

                        <Link to="/contact" className="btn btn-warning btn-lg mt-3">
                            Kontaktirajte nas
                        </Link>

                    </div>
                </section>

            </main>
        </>
    );
}

export default Home;